import moment from 'moment'
import { DateRangePicker } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'
import { requestArgsDateRange } from './columnsReqArgs'

export class OutcomeDateColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.OUTCOME_DATE

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Дата исхода',
        component: DateRangePicker,
        defaultValue: [null, null],
        props: {
          allowClear: true,
          allDay: true,
          allowEmpty: [true, true],
          disabledDate: currentDate => currentDate && currentDate.isAfter(moment()),
        },
      },
      width: 250,
      dataIndex: 'outcome_date',
      dataRender: outcome_date => outcome_date ? `${moment(outcome_date).format('DD.MM.YYYY')} (${moment().diff(outcome_date, 'years')})` : '-',
      sort: true,
    }

    super(column, settings)
  }

  _requestArgs = reqArgs => requestArgsDateRange(this.type, reqArgs)
}
